import React, {useEffect} from "react"
import AOS from "aos";
import '../styles/components/ContactForm.css'

const ContactForm = () => {

    useEffect(()=> {
        AOS.init({duration: 2000});
    }, []);

    return (
        <>
            <div className='contact-form'>
                <h2>أتشرف باستقبال رسائلك.</h2>
                <form>
                    <div className='inputs' data-aos='fade-left'>
                        <div className='name'>
                            <p>الاسم</p>
                            <input type='name'/>
                        </div>
                        <div className='email'>
                            <p>الإيميل</p>
                            <input type='email'/>
                        </div>
                        <div className='subject'>
                            <p>الموضوع</p>
                            <input type='text'/>
                        </div>
                        <div className='message'>
                            <p>الرسالة</p>
                            <input type='text'/>
                        </div>
                    </div>
                    <a className='submit' type='submit'>أرسل الرسالة</a>
                </form>
            </div>
        </>
    );
}

export default ContactForm;